import script from "./chargeLeaderboard.vue?vue&type=script&setup=true&lang=js"
export * from "./chargeLeaderboard.vue?vue&type=script&setup=true&lang=js"

import "./chargeLeaderboard.vue?vue&type=style&index=0&id=5739c9e5&scoped=true&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5739c9e5"]])

export default __exports__